<div class="rfe-substitute">

	<p class="rfe-substitute-lead text-center">
		<svg width="1em" class="svg-middle" viewBox="0 0 384 512" aria-hidden="true" focusable="false">
			<use xlink:href="@Assets/svg/symbol-defs.svg#file-invoice" />
		</svg>
		<strong>{{ $t('vm.components.popin.substitute-rfe.lead', [substituteName]) }}</strong>
	</p>

	<p>{{ $t('vm.components.popin.substitute-rfe.description') }}</p>

	<div class="notice-info">
		<template v-if="isAnnualSubscription">
			<p class="rfe-substitute-line">
				<span>{{ $t('vm.components.popin.substitute-rfe.next-invoice') }}</span>
				<strong>{{ formatAmount(nextInvoiceAmount) }}</strong>
			</p>
			<p class="text-sm">
				{{ $t('vm.components.popin.substitute-rfe.prorata-note', [prorataStartDateShort, subscriptionEndDateShort]) }}
			</p>
			<p class="rfe-substitute-line">
				<span>{{ $t('vm.components.popin.substitute-rfe.recurring-annual') }}</span>
				<strong>{{ formatAmount(recurringAmount) }}</strong>
			</p>
		</template>
		<p v-else class="rfe-substitute-line">
			<span>{{ $t('vm.components.popin.substitute-rfe.monthly-line') }}</span>
			<strong>{{ formatAmount(recurringAmount) }}</strong>
		</p>
	</div>

	<p class="text-sm">
		<svg width="1em" class="svg-middle" viewBox="0 0 512 512" aria-hidden="true" focusable="false">
			<use xlink:href="@Assets/svg/symbol-defs.svg#check-circle" />
		</svg>
		{{ $t('vm.components.popin.substitute-rfe.note') }}
	</p>

</div>
